// @flow strict

import * as React from 'react';
import queryString from 'query-string';
import { Progressbar } from '@ansarada/ace-react';
import styles from './styles.scss';

import type { SignupLocalStorageData } from './types';
import { getFreeTrialStorage } from './helpers';
import type { ProvisioningData } from '../FreeTrial/types';
import UserProfileForm from './UserProfileForm';
import UserProfilePlgForm from './UserProfilePlgForm';
import ThankYou from './ThankYou';

type PropTypes = {|
  thankYouTitle: string,
  thankYouMessage: string,
  thankYouTitleMS: string,
  thankYouMessageMS: string,
  thankYouImageDesktop: string,
  thankYouImageMobile: string,
  enabledMsStartupSignup: boolean,
  enabledStartupConferenceSignup: boolean,
  enabledUpflowy: boolean,
  spaClientId: string,
  authorizationServerDomain: string,
|};

const FreeTrialThankYou = (props: PropTypes) => {
  const {
    enabledUpflowy,
    spaClientId,
    authorizationServerDomain,
    enabledMsStartupSignup,
    enabledStartupConferenceSignup,
  } = props;
  const [email, setEmail] = React.useState('');
  const [progressPercentage, setProgressPercentage] = React.useState(5 / 6);
  const [provisioningData, setProvisioningData] = React.useState<ProvisioningData>({
    sessionId: '',
    signupToken: '',
    isProfileExists: false,
  });

  React.useEffect(() => {
    if (!window) return;

    if (!enabledMsStartupSignup && !enabledStartupConferenceSignup) {
      try {
        const parsed = queryString.parse(window.location.search);
        const storeId = atob(parsed.id);
        const {
          isProfileExists,
          sessionId,
          signupToken,
          userEmail,
        }: SignupLocalStorageData = getFreeTrialStorage(storeId);

        if (
          !(
            typeof sessionId === 'string' &&
            typeof signupToken === 'string' &&
            typeof userEmail === 'string' &&
            typeof isProfileExists === 'boolean'
          )
        ) {
          window.location.href = '/free-trial';
          return;
        }

        setEmail(userEmail);
        setProvisioningData({ isProfileExists, sessionId, signupToken });
      } catch (error) {
        window.location.href = '/free-trial';
      }
      return;
    }

    const parsed = queryString.parse(window.location.search);
    setEmail(atob(parsed.e) || '');
  }, []);

  React.useEffect(() => {
    if (provisioningData.sessionId) {
      setTimeout(() => setProgressPercentage(1), 200);
    }
  }, [provisioningData.sessionId]);

  const isMsStartupOrStartupConference =
    props.enabledMsStartupSignup || props.enabledStartupConferenceSignup;

  const title = isMsStartupOrStartupConference ? props.thankYouTitleMS : props.thankYouTitle;
  let message = isMsStartupOrStartupConference ? props.thankYouMessageMS : props.thankYouMessage;
  message = message.replace('[email]', email) || '';
  const bgDesktop = isMsStartupOrStartupConference ? props.thankYouImageDesktop : '';
  const bgMobile = isMsStartupOrStartupConference ? props.thankYouImageMobile : '';

  if (isMsStartupOrStartupConference) {
    return <ThankYou title={title} message={message} bgDesktop={bgDesktop} bgMobile={bgMobile} />;
  }

  return (
    provisioningData.sessionId && (
      <>
        <Progressbar percentValue={progressPercentage * 100} className={styles.progressBar} />
        {enabledUpflowy ? (
          <UserProfilePlgForm
            provisioningData={provisioningData}
            userEmail={email}
            spaClientId={spaClientId}
            authorizationServerDomain={authorizationServerDomain}
          />
        ) : (
          <UserProfileForm
            provisioningData={provisioningData}
            userEmail={email}
            spaClientId={spaClientId}
            authorizationServerDomain={authorizationServerDomain}
            enabledUpflowy={enabledUpflowy}
          />
        )}
      </>
    )
  );
};

export default FreeTrialThankYou;
